import { useGetLabReceptionAddressesQuery } from 'prove-common'

export const useTaskReceptionAddress = (
  labId: number | undefined,
  addressId: number | null | undefined,
  isOpen = true
) => {
  const query = useGetLabReceptionAddressesQuery(isOpen ? labId : undefined)
  const canSave =
    labId == null ||
    (query.isSuccess &&
      (query.data.length === 0
        ? addressId == null
        : query.data.some((address) => address.id === addressId)))
  const saveBlockedMessage = query.isError
    ? 'Kunne ikke laste mottaksadressene. Åpne Rediger i handlingsmenyen og prøv igjen.'
    : query.isPending
      ? 'Vent til mottaksadressene er lastet før du lagrer.'
      : 'Velg mottaksadresse via Rediger i handlingsmenyen før du lagrer andre endringer på oppgaven.'
  return { ...query, canSave, saveBlockedMessage }
}
